// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"5c95dbf9","380":"5ee6603f","477":"262a40e3","687":"523cb8c6","857":"7a0d7306","903":"d1a0471c","948":"d397b300","990":"cf94c468"}[chunkId] + ".chunk.js";
};